export default __webpack_public_path__ + "static/benifitImage4-fd1e5cbe332a245fc648bb2633f14b41.webp";